export default __webpack_public_path__ + "static/media/dg-white.8537eab1.svg";